var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-container is-vertical",attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view',{key:_vm.key})],1),_c('el-backtop',{staticStyle:{"right":"22px","bottom":"100px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }